/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Timber
 * 
 * 1 = Concrete
 */
export enum SubstrateType {
  Timber = 0,
  Concrete = 1
}
